/**
 * Automation Event Detection Hook
 * 
 * Watches for job state changes and emits system events
 * to the automation runner for rule evaluation.
 */

import { useEffect, useRef } from "react";
import { useOptionalAppData } from "@/data/AppDataContext";
import { useAutomationRunner } from "@/data/AutomationRunnerContext";
import type { Job } from "@/data/types";

export function useAutomationEventDetection() {
  const appData = useOptionalAppData();
  const jobs = appData?.jobs ?? [];
  const { detectAndEmit } = useAutomationRunner();
  const prevJobsRef = useRef<Job[]>([]);

  useEffect(() => {
    if (!appData) return;
    if (prevJobsRef.current.length > 0 && jobs.length > 0) {
      detectAndEmit(prevJobsRef.current, jobs);
    }
    prevJobsRef.current = jobs.map(j => ({ ...j }));
  }, [appData, jobs, detectAndEmit]);
}
